/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.SafeWalkV8CartHistorySync) return;

  let request = null;
  const drawerSelector = 'cart-drawer';
  const harnessSelector = '.cart-item--product-safewalk-no-pull-2';
  const registry = () => window.SafeWalkV8GiftPackRegistry || {};

  const sectionIds = () => {
    const ids = new Set(['cart-drawer', 'cart-icon-bubble']);
    document.querySelector(drawerSelector)?.getSectionsToRender?.()
      .forEach((section) => ids.add(section.id));
    return [...ids].filter(Boolean).slice(0, 5);
  };

  const isStale = (state, drawer = document.querySelector(drawerSelector)) => {
    if (!drawer || Number(state?.harnessQuantity || 0) <= 0) return false;
    return drawer.classList.contains('is-empty') || !drawer.querySelector(harnessSelector);
  };

  const replaceCartIcon = (html) => {
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('#cart-icon-bubble');
    const current = document.querySelector('#cart-icon-bubble');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  };

  const replaceCartDrawer = (html) => {
    const drawer = document.querySelector(drawerSelector);
    if (!html || !drawer) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector(drawerSelector);
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    drawer.className = fresh.className;
  };

  const render = (sections, itemCount) => {
    const drawer = document.querySelector(drawerSelector);
    if (drawer?.renderContents && sections?.['cart-drawer']) {
      drawer.renderContents({ sections, item_count: itemCount });
    } else {
      replaceCartDrawer(sections?.['cart-drawer']);
    }
    if (itemCount > 0) drawer?.classList.remove('is-empty');
    replaceCartIcon(sections?.['cart-icon-bubble']);
  };

  const refresh = (state) => {
    if (!isStale(state)) return Promise.resolve(false);
    if (request) return request;
    request = (async () => {
      const url = new URL('/cart', window.location.origin);
      url.searchParams.set('sections', sectionIds().join(','));
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error(`cart-history-sections-${response.status}`);
      render(await response.json(), Math.max(1, Number(state?.harnessQuantity || 0)));
      return true;
    })().catch((error) => {
      document.dispatchEvent(new CustomEvent('safewalk:cart-history-sync-error', {
        detail: { message: error instanceof Error ? error.message : 'unknown' }
      }));
      return false;
    }).finally(() => { request = null; });
    return request;
  };

  const recoverHistory = async () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer?.classList.contains('is-empty')) return false;
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error(`cart-history-read-${response.status}`);
    const cart = await response.json();
    const harnessQuantity = (cart?.items || []).reduce((sum, item) => (
      Number(item?.product_id || 0) === Number(registry().qualifyingProductId)
        ? sum + Number(item?.quantity || 0)
        : sum
    ), 0);
    return refresh({ harnessQuantity });
  };

  const onPageShow = (event) => {
    const navigation = window.performance?.getEntriesByType?.('navigation')?.[0];
    if (!event.persisted && navigation?.type !== 'back_forward') return;
    window.setTimeout(() => {
      recoverHistory().catch((error) => {
        document.dispatchEvent(new CustomEvent('safewalk:cart-history-sync-error', {
          detail: { message: error instanceof Error ? error.message : 'unknown' }
        }));
      });
    }, 180);
  };

  document.addEventListener('safewalk:gift-pack-contract', (event) => {
    refresh(event.detail);
  });
  window.addEventListener('pageshow', onPageShow);

  window.SafeWalkV8CartHistorySync = Object.freeze({ isStale, onPageShow, recoverHistory, refresh });
})();
